import React from 'react'

const NoTransactions = () => {
  return (
    <div className="text-center lead w-100 fw-bolder">No Transactions Made Yet</div>
  )
}

export default NoTransactions